import React, { useEffect, useState} from "react";
import { useForm} from "react-hook-form";
import {  useLocation  } from "react-router-dom";
import Header from "../components/Header";
import { useTranslation } from 'react-i18next';


export default function OrderModifyOrderer(props) {
    const { t } = useTranslation();

    const {register, handleSubmit, formState, trigger, setValue }= useForm({mode: 'onSubmit',
        defaultValues: { 
            ordererName: props.userInfo.userNm, 
            telNumber: props.userInfo.telno ,
            email : props.userInfo.email },
      });
    const{errors} = formState;
    const phoneRegex = /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/
    

    function regPhoneNumber(e) {
        const result = e.target.value
          .replace(/[^0-9.]/g, "")
          .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
          .replace(/(-{1,2})$/g, "");
          setValue('telNumber', result, { shouldValidate: true })          
      }

    const location = useLocation();
    const onSubmit = async data=> {
        data.userNm = data.ordererName;
        data.telno = data.telNumber;
        props.setOrdererInfo(data);
        props.closeFn(false)
    }
    useEffect(() => {
        trigger()
      }, []);
    return(
        <div className={props.modal?'modalPage':'justPage'}>
          
            <Header type={props.modal?'modal':'black'} pageTitle={t(`Message.ordrr_form_modify_title`)} closeFn={props.closeFn}/>
            <div className="pd20">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <ul className="dfColG20">
                        <li className="idLi">
                            <p>{t(`Message.ordrr_form_label_name`)}</p>
                            <input type="text" maxLength={50} placeholder={t(`Message.ordrr_form_hint_name`)} {...register("ordererName", { required: t(`Message.ordrr_form_required_name`)})} />
                            {errors.ordererName && <p role="alert" className="alertRed">{errors.ordererName.message}</p>}
                        </li>
                        <li className="idLi">
                            <p>{t(`Message.ordrr_form_label_mobile`)}</p>
                            <input type="tel" maxLength={13} placeholder={t(`Message.ordrr_form_hint_mobile`)}  {...register("telNumber", { onChange: (e) => {regPhoneNumber(e)}, required: t(`Message.ordrr_form_required_mobile`), pattern: {value: phoneRegex, message:"올바른 휴대폰 형식이 아닙니다."}})}/>
                            {errors.telNumber && <p role="alert" className="alertRed">{errors.telNumber.message}</p>}
                        </li>
                        <li className="idLi">
                            <p>{t(`Message.ordrr_form_label_email`)}</p>
                            <input type="email" maxLength={60} placeholder={t(`Message.ordrr_form_hint_email`)} {...register("email", { required: t(`Message.ordrr_form_required_email`)})} />
                            {errors.email && <p role="alert" className="alertRed">{errors.email.message}</p>}
                        </li>
                    </ul>
                    <button type="submit" className="floatBtn">{t(`Message.saveBtn`)}</button>  
                </form>
            </div>
        </div>
    );
};